import React from "react";
import BlackTooltip from "@components/tooltip/BlackTooltip";
import { formatTextFromTextArea } from "@helpers/_functions";

/**
 * @typedef Props
 * @property {string=} className
 * @property {string=} description
 * @property {string=} lineClamp
 * @property {string=} textColor
 * @property {boolean=} withToolTip  
 * @property {boolean=} noTransform 
 */
export default function Description({
  withToolTip = false,
  className = "arh-font-poppins arh-font-medium arh-text-xs arh-mb-0",
  description = "",
  textColor = "arh-text-[#8B8F91]",
  noTransform = true ,
  lineClamp="arh-line-clamp-3"
}) {
  const baseStyle = { whiteSpace: "pre-wrap" };

  // Version normale
  const content = (
    <p className={`${className} ${textColor} ${lineClamp} !arh-mb-0`} style={baseStyle}>
      {noTransform ? description : formatTextFromTextArea(description)}
    </p>
  );

  // Version tooltip
  const tooltipContent = (
    <p className={className} style={{ ...baseStyle, color: "white" }}>
      {noTransform ? description : formatTextFromTextArea(description)}
    </p>
  );

  return withToolTip ? (
    <BlackTooltip placement="top" title={tooltipContent} id="id">
      {content}
    </BlackTooltip>
  ) : (
    content
  );
}
